import { useContext, useEffect, useState } from 'react';
import Link from 'next/link';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

import { getLanguageId } from '@helpers/language';
import PageContext from '@contexts/PageContext';
import { Container, Button } from '@components';
import { checkEnabled, checkValue } from '@components/OptionalFeature';

const DynamicImage = dynamic(() => import('@components/DynamicImage'), {
  ssr: false
});
import styles from './Promotions.module.scss';

const Promotions = ({ data, DarkMode, componentIsAvailable, showTitle, componentTitle }) => {
  const pageData = useContext(PageContext);
  const router = useRouter();
  const { locale } = router;
  const [darkMode, setDarkMode] = useState(false);

  useEffect(() => {
    setDarkMode(DarkMode);
  }, []);

  // check Promotions has background Hero
  const backgroundEnabled = checkEnabled(data?.DisplayOptions, 'BackgroundHero');

  // check LinkOut
  const LinkOutEnabled = checkEnabled(data?.DisplayOptions, 'LinkOut');
  const sectionTitle = checkValue(data?.DisplayOptions, 'ComponentHeaderTitleText', locale);
  const postTextBodyEnabled = checkEnabled(data?.DisplayOptions, 'PostTextBody');
  const shortDescriptionEnabled = checkEnabled(data?.DisplayOptions, 'ShortDescription');

  // Promotion Value key
  const promotionOptionInfo = data?.DisplayOptions.filter((options) => {
    return options.DisplayOptionKey === 'Category';
  })[0]?.OptionInformation;

  
  // Promotion content for
    const promotionRelatedPost = pageData?.RelatedPosts.find((post) => {
      return post?.p?.PostTags[0]?.TagDescription?.Code === promotionOptionInfo;
    })?.p?.PostText.find(
      ({ LanguageId }) => parseInt(LanguageId) === getLanguageId(locale),
    );

    const postTextBody = promotionRelatedPost?.PostTextBody;
  const shortDescription = promotionRelatedPost?.ShortDescription;


  return componentIsAvailable && promotionRelatedPost ? (
    <section className={styles.Section}>
      {!darkMode ? (
        <Container className={styles.Container}>
          {showTitle && <h2 className={styles.Title}>{sectionTitle}</h2>}
          <div className={styles.PromotionsBox}>
            {backgroundEnabled && (
              <DynamicImage
                imgSrc={`/api/static/media/byFile/posts/${promotionRelatedPost?.PostId}/post/1_N_N_N_I_1600X900.JPG`}
                sizes={'1600X900'}
                className={styles.Image}
                alt={promotionRelatedPost?.ImageAccessibilityInfo}
                layout="fill"
              />
            )}
            <div className={styles.Content}>
              <h4 className={styles.PromotionTitle}>{promotionRelatedPost?.Subject}</h4>
              {shortDescriptionEnabled && <p>{shortDescription}</p>}
              {postTextBodyEnabled && <div dangerouslySetInnerHTML={{ __html: postTextBody }} />}

              {LinkOutEnabled && (
                <Link href={promotionRelatedPost ? promotionRelatedPost.Link : ''} prefetch={false}>
                  <a className={styles.More}>
                    {promotionRelatedPost?.ButtonText} <FontAwesomeIcon icon={faChevronRight} />
                  </a>
                </Link>
              )}
            </div>
          </div>
        </Container>
      ) : (
        <>
          {showTitle && <h2 className={styles.Title}>{componentTitle}</h2>}
          <div className={styles.DMPromotionsBox}>
            {backgroundEnabled && (
              <img
                className={styles.Image}
                src={`/api/static/media/byFile/posts/${promotionRelatedPost?.PostId}/post/1_N_N_N_I_1600X900.JPG`}
                layout="fill"
                alt={promotionRelatedPost.ImageAccessibilityInfo}
              />
            )}

            <div className={styles.Content}>
              <div></div>
              <div className={styles.Information}>
                <h2 className={styles.Subject}>{promotionRelatedPost?.Subject}</h2>
                <p>{promotionRelatedPost?.ShortDescription}</p>
                {LinkOutEnabled && promotionRelatedPost?.ButtonText && (
                  <Button animated href={promotionRelatedPost ? promotionRelatedPost.Link : ''}>
                    {promotionRelatedPost?.ButtonText}
                  </Button>
                )}
              </div>
              <div></div>
            </div>
          </div>
        </>
      )}
    </section>
  ) : null;
};

export default Promotions;
